import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store } from "lucide-react";
import { api } from "@/lib/api";
import { usePageMeta } from "@/components/Share";
import { ListingCard } from "@/components/MarketBits";

const KINDS = [["", "All"], ["product", "Products"], ["service", "Services"]];

export default function Market() {
  const [data, setData] = useState(null);
  const [kind, setKind] = useState("");
  const [category, setCategory] = useState("");
  usePageMeta("Market", "Sun-lover products and naturist-friendly services from New Zealand sellers.");

  useEffect(() => {
    api.get("/market/listings", { params: { kind: kind || undefined, category: category || undefined } })
      .then(({ data }) => setData(data)).catch(() => setData({ items: [], categories: [] }));
  }, [kind, category]);

  const btn = (on) => `px-4 py-1.5 text-sm border transition-colors ${on ? "bg-[#1f402b] text-white border-[#1f402b]" : "border-[#e2dcd4] text-[#3c4a41] hover:border-[#1f402b]"}`;

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20" data-testid="market-page">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <p className="eyebrow rise">Market</p>
          <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f]">For sun lovers, by sun lovers.</h1>
          <p className="rise d2 mt-5 text-[#5a665e] max-w-xl leading-relaxed">Sun care, beach gear, stays and experiences from New Zealand sellers. Every advert is checked before it goes live. Contact sellers directly from any advert.</p>
        </div>
        <div className="lg:col-span-4 border border-[#e2dcd4] bg-white p-6" data-testid="market-sell-cta">
          <Store size={18} className="text-[#c5903b]" />
          <p className="mt-3 text-[#1a261f]"><strong>FREE to list until 1 January 2027</strong>, then NZ$5 a month with 28 adverts included.</p>
          <Link to="/sell" className="mt-4 inline-block bg-[#1f402b] text-white px-5 py-2.5 text-sm hover:bg-[#2c5a3d]" data-testid="market-start-selling">Start selling free</Link>
        </div>
      </div>
      <div className="mt-12 flex flex-wrap gap-2" data-testid="market-kind-filter">
        {KINDS.map(([k, v]) => <button key={v} onClick={() => setKind(k)} className={btn(kind === k)} data-testid={`market-kind-${v.toLowerCase()}`}>{v}</button>)}
        <select value={category} onChange={(e) => setCategory(e.target.value)} data-testid="market-category-select"
          className="ml-auto border border-[#e2dcd4] bg-white px-3 py-1.5 text-sm">
          <option value="">All categories</option>
          {(data?.categories || []).map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>
      {data === null ? <p className="mt-12 text-sm text-[#5a665e]">Loading…</p>
        : data.items.length === 0 ? <p className="mt-12 text-[#5a665e] border-t border-[#e2dcd4] pt-8" data-testid="market-empty">No adverts here yet.</p>
        : (
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
            {data.items.map((i) => <ListingCard key={i.id} item={i} />)}
          </div>
        )}
    </div>
  );
}
